import React from 'react';
import PropTypes from 'prop-types';
import AppOpenButton from "./AppOpenButton";
import './AppMobileBanner.css';
import AppIconRounded from '../icons/AppIconRounded';
import IconStarBlack from '../icons/IconStarBlack';

export default function AppMobileBanner({hostname, userAgent}) {
    return (
        <div className="Mobile-banner-container Navigation-navbar navbar navbar-expand-md">
            <div className='container'>
                <div className='Mobile-banner'>
                    <AppIconRounded className="Logo" />
                    <div className='Content'>
                        <div className='Title'>후루츠 - 300만 패션 러버와 함께 디깅해요!</div>
                        <div className='Description' aria-label="평점 4.9점">
                            <div aria-hidden="true">
                                <IconStarBlack />
                                <IconStarBlack />
                                <IconStarBlack />
                                <IconStarBlack />
                                <IconStarBlack />
                            </div>
                            <div className='Text'>(4.9)</div>
                        </div>
                    </div>
                </div>
                <div className="AppOpenButton-wrapper">
                    <AppOpenButton hostname={hostname} userAgent={userAgent}/>
                </div>
            </div>
        </div>
    );
}

AppMobileBanner.propTypes = {
    hostname: PropTypes.string.isRequired,
    userAgent: PropTypes.string.isRequired,
};
